module.exports = __webpack_public_path__ + "static/media/powerup.bff09a73.mp3";